import { CONFIG } from './config_online.js'

export default CONFIG